<template>
  <div class="templeteWrap">
    <div class="aside" :class="{'deActive': deActive}">
      <h3>장비템플릿 관리</h3>
      <div class="textInput">
        <input type="text" ref="searchInputTag" v-model="searchKeyword" placeholder="검색어를 입력하세요." />
        <button class="searchButton">search</button>
      </div>
      <div class="overflow">
        <Templates :templateMode="true" :searchKeyword="searchKeyword" @click="loadTemplate"/>
      </div>
      <div class="hideBtn">
        <button class="equimList" @click.stop="toggleHandler">장비목록</button>
      </div>
    </div>
    <div class="tree">
      <Editor v-if="tagTempleteData != null" @mount="(info)=>{editorInfo=info}" :firstBln="firstBln" :treeMode="treeMode" :tagTempleteData="tagTempleteData"></Editor>
      <loading :visible="loading" />
    </div>
  </div>
  </template>
  
  <script>
  import CommNew from "@processEditor/CommNew";
  import { v4 } from "uuid";
  import Editor from './treeNew.vue' ;
  
  export default {
    mixins:[CommNew],
    components : {
      Loading : _=> import( '@common/loading' ) ,  
      Templates : _=> import( '@common/template/Protocols' ) ,  
      Editor, 
    } , 
    data () {
      return {
        searchKeyword : "",
        loading : false , 
        editorInfo : {},
        firstBln : true , 
        deActive : false,
        treeMode : "templeteEdit",
        // treeMode : "readonly",
        tagTempleteData : null,
      }
    },
    async mounted () {
      const 
      { companyName , id , name } = await this.$wApi.user.me() , 
      { 
        updateData , 
        getDefaultTemplate , 
      } = this ;
      updateData({ userName : name }) ; 
  
    } , 
    watch : {
      editorInfo : (e)=>{
        console.log("editer loaded");
      }
    },
    methods:{
      toggleHandler(){
        this.deActive = !this.deActive;
      }, 
      updateData ( obj ) {
        for ( let [ k , v ] of Object.entries( obj )) {
          this[ k ] = v ; 
        }
      } , 
      async loadTemplate ( item ) {
        // console.log("item",item)
        if( typeof item.content === "string" ) item.content = JSON.parse( item.content );
        this.tagTempleteData = item;

        this.firstBln = false ; 
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    .textInput {
      display: inline-flex; align-items: center;
      gap : 0 10px;
      width: 100%; max-width: 210px; min-height: 35px;
      padding: 3px 20px;  
      border-radius: 35px;
      border: 1px solid #666;
      font-size: 13px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
      background-color: #fff;
      margin-left: 8px; 
      margin-right: 8px; 
      margin-bottom:20px;
      input {
        display: block;
        width: 100%;
        &::placeholder { font-size: 13px; }
        appearance: none;
        border: none;
      }
      button {
        display: block;
        width: 20px; height: 20px;
        font-size: 0;
        &.searchButton {
          background: url('../../assets/icons/magnify.svg') center no-repeat;
          background-size: 18px;
          transform: scale(1);
          transition: transform .4s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
    }
    .templeteWrap {
      background-color: $gray-f5; 
      position:relative;
      height: 100%;
      width:100%;


      .tree{
        width:100%;
        height:100%;
      }
      .aside {
        background-color: $white; 
        position:absolute;
        left:0;top:0;bottom:0;
        z-index:10;
        padding: 30px 10px 0 34px;
        width: 300px; height: 100%;
        // overflow: hidden;
        @include text-prt-sb;
        transform: translate(0, 0);
        transition: transform 0.3s;
        &.deActive{
          transform: translate(-100%, 0);
          .hideBtn{
            .equimList{
              &::before{
                transform: rotate( 0deg ); 
              }
            }
          }
        }
        h3 {
          @include gateway-h3Title;  
        }

        .overflow {
          height: calc( 100% - 130px ); 
          overflow: auto; 
          @include scrlbar; 
        } 

        .hideBtn{
          position:absolute;
          bottom:20px;
          right:-100px;
          width:100px;
          background: #fff;
          .equimList {
            display: flex; 
            align-items: center; 
            // width: 146px; 
            @include text-prt;
            @include text-prt-sb;

            &::before {
              content: ''; 
              display: inline-flex; 
              width: 24px; height: 24px; 
              background: url( '@/assets/icons/arrow.svg' ) no-repeat center; 
              margin-right: 8px; 
              transform: rotate( 180deg ); 
              transition: transform var( --moveDuration ); 
            }
            color: $gray-6; 
          }        

        }

      } // end of .aside 

    } // end of .gatewrayWrap
  </style>